import fetchData from "../helper/axios";
import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { Countries, CountryData } from "./types";

interface CountriesProviderProps {
    children: ReactNode;
    remoteUrl: string;
}
interface CountriesContextType {
    countries: Countries;
    selectedCountry: CountryData | null;
    setSelectedCountry: (country: CountryData | null) => void;
    remoteApiUrl: string;
}

const CountriesContext = createContext<CountriesContextType | undefined>(undefined);

const CountriesProvider = ({ remoteUrl, children }: CountriesProviderProps) => {
    const [countries, setCountries] = useState<Countries>([]);
    const [selectedCountry, setSelectedCountry] = useState<CountryData | null>(null); // State for selected country

    useEffect(() => {
        const getCountriesData = async () => {
            try {
                const result = await fetchData<Countries>(remoteUrl);
                setCountries(result);
            } catch (error) {
                console.error("Error:", error);
            }
        };

        getCountriesData();
    }, [remoteUrl]);

    return (
        <CountriesContext.Provider
            value={{
                countries,
                selectedCountry,
                setSelectedCountry,
                remoteApiUrl: remoteUrl
            }}
        >
            {children}
        </CountriesContext.Provider>
    );
};

const useCountriesData = (): CountriesContextType => {
    const context = useContext(CountriesContext);
    if (context === undefined) {
        throw new Error("useCountriesData must be used within a CountriesProvider");
    }
    return context;
};

export { CountriesProvider, useCountriesData };
